/* eslint-disable */
// /src/pages/MallHomePage.jsx
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { getMeterAccountByAccountId } from "../services/meterAccountsService";
import { useAppConfig } from "../context/AppConfigContext";
import { useDriverStatusContext } from "context/DriverStatusContext";
import PageTopBar from "../components/PageTopBar";

/* ===== Layout ===== */
const Wrap = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #d7e8ff 0%, #eaf3ff 100%);
  display: flex;
  flex-direction: column;
`;

const Sheet = styled.div`
  background: #f7faff;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.05);
`;


const Body = styled.div`
  flex: 1;
  padding: 16px;
  row-gap: 16px;
`;

/* ===== Header 이미지 공통 ===== */
const HeaderSection = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${({ $mt }) => ($mt != null ? $mt : 24)}px;
  margin-bottom: 16px;
  /* 🔹 배너가 아직 안 나와도 이만큼은 항상 자리 확보 */
  min-height: 120px;
`;

const HeaderImg = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
`;

/* ===== Cards ===== */
const Cards = styled.div`
  display: grid;
  gap: 14px;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

// 카드별 위쪽 여백 튜닝용
const CardSlot = styled.div`
  margin-top: ${({ $mt }) => ($mt != null ? $mt : 0)}px;
`;

/* ===== Mall Card ===== */
const MallCardRoot = styled.button`
  appearance: none;
  border: 0;
  cursor: pointer;
  outline: none;
  position: relative;
  border-radius: 20px;
  background: ${(p) => (p.$locked ? "#eef2f7" : p.$bg || "#e6faf7")};
  padding: 22px 18px;
  height: 140px;
  width: 100%;
  margin-bottom: 8px;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  box-shadow: ${(p) => (p.$locked ? "none" : "0 8px 20px rgba(0, 0, 0, 0.06)")};
  transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;

  &:hover {
    transform: ${(p) => (p.$locked ? "none" : "translateY(-2px)")};
    box-shadow: ${(p) => (p.$locked ? "none" : "0 12px 26px rgba(0, 0, 0, 0.1)")};
  }
  &:active {
    transform: none;
    box-shadow: ${(p) => (p.$locked ? "none" : "0 8px 20px rgba(0, 0, 0, 0.08)")};
  }
`;


const MallText = styled.div`
  h2 {
    margin: 0 0 6px;
    font-size: 22px;
    font-weight: 900;
    color: #0f172a;
  }
  p {
    margin: 0;
    font-size: 14px;
    color: #64748b;
  }
`;

const Mascot = styled.div`
  width: 84px;
  height: 84px;
  border-radius: 20px;
  background: #fff;
  display: grid;
  place-items: center;
  font-size: 36px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
`;

const LockBadge = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;

const LockCircle = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.12);
  display: grid;
  place-items: center;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.18);
`;

const LockImg = styled.img`
  width: 54px;
  height: auto;
  object-fit: contain;
  display: block;
`;

const BottomPad = styled.div`
  height: max(24px, env(safe-area-inset-bottom));
`;

/* ===== Spinner (FranchiseApplyPage 스타일) ===== */
const SpinnerWrap = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top-color: #999;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

function MallCard({ title, subtitle, icon, onClick, bgColor, locked = false, lockImg = "" }) {
  return (
    <MallCardRoot onClick={onClick} $bg={bgColor} $locked={locked}>
      <MallText>
        <h2 style={{ color: locked ? "#64748b" : undefined }}>{title}</h2>
        <p style={{ color: locked ? "#94a3b8" : undefined }}>{subtitle}</p>
      </MallText>

      <Mascot style={{ opacity: locked ? 0.5 : 1 }}>
        {icon}
      </Mascot>

      {locked && (
        <LockBadge>
          {lockImg ? (
            <LockImg src={lockImg} alt="locked" />
          ) : (
            <LockCircle>
              <span style={{ fontSize: 34 }}>🔒</span>
            </LockCircle>
          )}
        </LockBadge>
      )}
    </MallCardRoot>
  );
}


/* ===== Page ===== */
export default function MallHomePage() {
  const nav = useNavigate();

  // 🚕 드라이버 상태 컨텍스트 — username으로 meter_accounts.accountId 체크
  const { loading, username, status } = useDriverStatusContext();
  const [meterAllowed, setMeterAllowed] = useState(false);

  const { config, loading: configLoading } = useAppConfig();
  const detail = config.detailScreens || {};
  const shopping = detail.shoppingMall || {};

  const shopLocks = shopping.locks || {};
  const lockFranchise = shopLocks.franchise || {};
  const lockMeter = shopLocks.meter || {};


  const accessCfg = config.access || {};
  const guardMall = accessCfg.mall || {}; // AdminAccessControl에서 설정하는 mall 가드

  const headerImg = shopping.headerImg || "";
  const layout = shopping.layout || {};
  const cardsFromConfig = Array.isArray(shopping.cards)
    ? shopping.cards
    : [
      {
        id: "franchiseShop",
        title: "가맹점",
        subtitle: "가맹 회원 전용 특가와 전용 상품",
        cardBgColor: "#95b1ea",
      },
      {
        id: "meterShop",
        title: "미터점",
        subtitle: "누구나 구매 가능한 공용 마켓",
        cardBgColor: "#52c5ff",
      },
    ];

  // Mall 화면 설정 준비 여부
  const ready = !configLoading && !loading && (headerImg || cardsFromConfig.length > 0);

  const showGuardMessage = (message, fallback) => {
    window.alert(message || fallback);
  };

  useEffect(() => {
    let alive = true;

    (async () => {
      if (loading) return;

      if (!username) {
        if (alive) setMeterAllowed(false);
        return;
      }

      try {
        const acc = await getMeterAccountByAccountId(username);
        if (!alive) return;
        setMeterAllowed(!!acc);
      } catch (e) {
        console.error("[MallHomePage] getMeterAccountByAccountId error:", e);
        if (alive) setMeterAllowed(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, [loading, username]);

  // 🔹 가맹점 몰 가드: AdminAccessControl.mall + DriverStatus.status("member") 기준
  const goFranchise = () => {
    // 가드 ON + 멤버가 아닌 경우 → 관리자 설정 메시지로 막기
    if (guardMall.enabled && status !== "member") {
      showGuardMessage(
        guardMall.message,
        "쇼핑몰은 가맹 회원에게만 제공되는 서비스입니다.\n회원가입 및 승인 후 이용해 주세요."
      );
      return;
    }

    nav("/franchise-store");
  };

  const goMeter = () => {
    if (!meterAllowed) {
      window.alert(
        "등록된 미터점 계정만 이용 가능한 메뉴입니다.\n관리자에게 문의해 주세요."
      );
      return;
    }
    nav("/store");
  };

  const handleCardClick = (id) => {
    if (id === "franchiseShop") {
      if (lockFranchise.enabled) {
        showGuardMessage(
          lockFranchise.message,
          "현재 점검 중입니다.\n관리자에게 문의해 주세요."
        );
        return;
      }

      goFranchise();

 

    } else if (id === "meterShop") {

      if (lockMeter.enabled) {
        showGuardMessage(
          lockMeter.message,
          "현재 점검 중입니다.\n관리자에게 문의해 주세요."
        );
        return;
      }

      goMeter();

  


    } else {
      console.warn("[MallHome] unknown card id:", id);
    }
  };

  return (
    <Wrap>
      <Sheet>
        <PageTopBar />

        <Body>
          <HeaderSection $mt={layout.headerTop}>
            {headerImg ? (
              <HeaderImg src={headerImg} alt="쇼핑몰 배너" />
            ) : (
              // 🔹 이미지 로딩 전에는 빈 박스(또는 스켈레톤)로 공간만 차지
              <div
                style={{
                  width: "100%",
                  maxWidth: 480,
                  height: 120,
                }}
              />
            )}
          </HeaderSection>

          <Cards>
            {cardsFromConfig.map((card) => {
              const isMeter = card.id === "meterShop";
              const isFranchise = card.id === "franchiseShop";

              const mt =
                isFranchise && layout.firstCardTop != null
                  ? layout.firstCardTop
                  : isMeter && layout.secondCardTop != null
                    ? layout.secondCardTop
                    : 0;

              const locked = isFranchise
                ? !!lockFranchise.enabled
                : isMeter
                  ? !!lockMeter.enabled
                  : false;

              const lockImg = isFranchise
                ? (lockFranchise.iconImg || "")
                : isMeter
                  ? (lockMeter.iconImg || "")
                  : "";

              return (
                <CardSlot key={card.id || card.title} $mt={mt}>
                  <MallCard
                    title={card.title}
                    subtitle={card.subtitle}
                    icon={card.iconImg ? "🛒" : "🧸"}
                    bgColor={card.cardBgColor}
                    locked={locked}
                    lockImg={lockImg}
                    onClick={() => handleCardClick(card.id)}
                  />
                </CardSlot>
              );
            })}
          </Cards>


          <BottomPad />
        </Body>


      </Sheet>
    </Wrap>
  );
}
